import React from 'react';
import { Helmet } from 'react-helmet';

const PrivacyMain = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>Privacy Policy - U Brand It</title>
                <meta name="description" content="U Brand It Privacy Policy - How we collect, use, and protect your personal information." />
            </Helmet>

            {/* Page Header Start */}
            <section className="page-header">
                <div className="page-header__bg" style={{backgroundImage: 'url(/assets/images/backgrounds/page-header-bg.jpg)'}}></div>
                <div className="container">
                    <div className="page-header__inner">
                        <h2>Privacy Policy</h2>
                        <div className="thm-breadcrumb__box">
                            <ul className="thm-breadcrumb list-unstyled">
                                <li><a href="/">Home</a></li>
                                <li><span>·</span></li>
                                <li>Privacy Policy</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* Page Header End */}

            {/* Privacy Policy Content Start */}
            <section className="privacy-policy">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="privacy-policy__content">
                                <div className="privacy-policy__text-box">
                                    <h3>Privacy Policy</h3>
                                    <p><strong>Last updated:</strong> January 2024</p>
                                    
                                    <h4>Information We Collect</h4>
                                    <p>We collect information you provide directly to us, such as when you:</p>
                                    <ul>
                                        <li>Submit a contact form or request a quote</li>
                                        <li>Subscribe to our newsletter</li>
                                        <li>Contact us via phone or email</li>
                                        <li>Visit our website</li>
                                    </ul>

                                    <h4>How We Use Your Information</h4>
                                    <p>We use the information we collect to:</p>
                                    <ul>
                                        <li>Provide and deliver products and services</li>
                                        <li>Process and fulfill orders</li>
                                        <li>Respond to your inquiries and provide customer support</li>
                                        <li>Send you promotional materials and updates (with your consent)</li>
                                        <li>Improve our website and services</li>
                                    </ul>

                                    <h4>Information Sharing</h4>
                                    <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this privacy policy. We may share your information with:</p>
                                    <ul>
                                        <li>Service providers who assist us in operating our business</li>
                                        <li>Legal authorities when required by law</li>
                                    </ul>

                                    <h4>Data Security</h4>
                                    <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>

                                    <h4>Your Rights</h4>
                                    <p>You have the right to:</p>
                                    <ul>
                                        <li>Access your personal information</li>
                                        <li>Correct inaccurate information</li>
                                        <li>Request deletion of your information</li>
                                        <li>Opt-out of marketing communications</li>
                                    </ul>

                                    <h4>Contact Us</h4>
                                    <p>If you have any questions about this Privacy Policy, please contact us:</p>
                                    <p>
                                        <strong>U Brand It</strong><br />
                                        Phone: <a href="tel:8007215822" style={{color: 'inherit'}}>800-721-5822</a><br />
                                        Email: <a href="mailto:general@ubranditpa.com" style={{color: 'inherit'}}>general@ubranditpa.com</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Privacy Policy Content End */}
        </React.Fragment>
    );
};

export default PrivacyMain;